var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHowItWorksShortLine({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 49,
    viewBox: "0 0 6 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00001 49.0035L3 0",
    stroke: "url(#paint0_linear_452_1238)",
    strokeWidth: 6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_452_1238",
    x1: 3,
    y1: 24.5017,
    x2: -44.6574,
    y2: -59.1786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0398851,
    stopColor: "#31D054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F64E4",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowItWorksShortLine);
export default __webpack_public_path__ + "static/media/howItWorks_short_line.9c5fd94a3fa9d223c70375207f926e7d.svg";
export { ForwardRef as ReactComponent };